// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__YRwy-","fileBtn":"File_fileBtn__25JkU","closeBtn":"File_closeBtn__1KERn","fileSelected":"File_fileSelected__33Bv7","disabled":"File_disabled__2FrWe"};